var map = {
	"./fonts/hk-grotesk.bold.ttf": "4e4f",
	"./fonts/hk-grotesk.light.ttf": "df43",
	"./fonts/hk-grotesk.medium.ttf": "0cc4",
	"./fonts/hk-grotesk.regular.ttf": "d3dd",
	"./fonts/hk-grotesk.semibold.ttf": "d1cf",
	"./logo.png": "cf05",
	"./pdf_icon.svg": "dd99"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";